<template>
  <div class="pa-4">
    <v-card class="elevation-0" v-if="document">
      <v-card-title>{{ document.template.name }}</v-card-title>
      <v-card-title v-if="document.user">
        <v-avatar v-if="document.user.userImageSmall" size="20">
          <v-img style="width:100px" :src="userFile(document.user.userImageSmall)" />
        </v-avatar>
        <span class="ml-1">{{ document.user.displayName }}</span>
        <span class="supporting-text" style="margin-left:5px">{{ $d(new Date(document.time), "long",
          $i18n.locale) }}</span>
      </v-card-title>
      <v-card-title v-if="document.guardianUser" class="text-caption gray--text">
        <v-avatar v-if="document.guardianUser.userImageSmall" size="20">
          <v-img style="width:100px" :src="userFile(document.guardianUser.userImageSmall)" />
        </v-avatar>
        <span class="ml-1">{{ $t('message.completed_by') }}:</span>
        <span class="ml-1">{{ document.guardianUser.displayName }}</span>
      </v-card-title>
      <v-card elevation="0" outlined>
        <div v-if="document && document.answers">
          <template v-for="(i, index) in document.answers">
            <v-card :key="'question_' + index" class="elevation-0 question-card">
              <v-card-title class="text-subtitle-1">{{ index + 1 }} - {{ i.question }}
                <span class="required ml-1" v-if="i.required">*</span></v-card-title>
              <v-card-text class="mt-0 pt-0">
                <span class="supporting-text" v-if="!i.answer && typeof i.answerBoolean == 'undefined'">N/A</span>
                <span class="supporting-text" v-else-if="!i.answer">{{ i.answerBoolean ? $t('message.true') :
                  $t('message.false') }}</span>
                <span class="supporting-text page-description" v-else>{{ i.answer }}</span>
              </v-card-text>
            </v-card>
          </template>
        </div>
      </v-card>
      <v-card-actions>
        <v-btn elevation="0" small @click="goBack()">{{ $t('message.back') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else elevation="0">
      <v-card-text>
        <circles-loader></circles-loader>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import Api from '@/services/Api2';

export default {
  data() {
    return {
      documentId: this.$route.params.documentId,
      document: null,
      archiveDialog: null
    };
  },
  components: {
    CirclesLoader
  },
  created() {
    if (this.documentId) {
      Api().get('documents/academy/' + this.$store.state.managedAcademy + '/surveys/' + this.documentId)
        .then(response => {
          if (response) {
            this.document = response.data.document;
          }
        }).catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    }
  },
};
</script>

<style scoped>
.waiver {
  font-family: 'Bradley Hand';
  color: black
}

.required {
  font-size: 19px;
  color: #EC7063
}
</style>